import store from "@utils/store/cookie";
import { getUserInfo } from "@api/user";
import dialog from "@utils/dialog";

const LOGIN_KEY = "ajt-token";
const USER_INFO_KEY = "user-info";
const SHARE_UID_KEY = "share-uid";
const state = {
  footer: true,
  home: true,
  homeActive: false,
  token: store.get(LOGIN_KEY) || null,
  backgroundColor: "#fff",
  userInfo: store.get(USER_INFO_KEY, true) || {},
  share_uid: store.get(SHARE_UID_KEY) || 0 // 分享者的uid
};
const mutations = {
  SHOW_FOOTER(state) {
    state.footer = true;
  },
  HIDE_FOOTER(state) {
    state.footer = false;
  },
  SHOW_HOME(state) {
    state.home = true;
  },
  HIDE_HOME(state) {
    state.home = false;
  },
  OPEN_HOME(state) {
    state.homeActive = true;
  },
  CLOSE_HOME(state) {
    state.homeActive = false;
  },
  LOGIN(state, token) {
    state.token = token;
    store.set(LOGIN_KEY, token, 30);
  },
  SHARE_UID(state, share_uid) {
    state.share_uid = share_uid;
    store.set(SHARE_UID_KEY, share_uid, 365);
    console.log("vuex-start-init-SHARE_UID", state);
    // console.log('SHARE_UID',state.userInfo)
    // if (state.userInfo && !state.userInfo.parent_id && state.userInfo.id) {
    //   login({ id: state.userInfo.id, parent_id: share_uid })
    //     .then(() => {
    //       state.userInfo.parent_id = share_uid;
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // }
  },
  LOGOUT(state) {
    state.token = undefined;
    state.userInfo = {};
    store.remove(LOGIN_KEY);
    store.remove(USER_INFO_KEY);
  },
  BACKGROUND_COLOR(state, color) {
    state.color = color;
    document.body.style.backgroundColor = color;
  },
  UPDATE_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
    store.set(USER_INFO_KEY, JSON.stringify(userInfo), 365);
  }
};

const actions = {
  USERINFO({ state, commit }, force) {
    if (state.userInfo !== null && !force)
      return Promise.resolve(state.userInfo);
    else
      return new Promise(reslove => {
        getUserInfo().then(res => {
          commit("UPDATE_USERINFO", res.data);
          reslove(res.data);
        });
      }).catch(() => {
        dialog.error("获取信息失败!");
      });
  }
};

export default {
  state,
  mutations,
  actions
};
